import type { KeyboardLayoutRequirements } from './keyboard-layout-requirements';

export const Standard88Layout: KeyboardLayoutRequirements = {
  length: 88,
  startNote: { letter: 'A', octave: 0 },
};
